import { render, staticRenderFns } from "./WashService.vue?vue&type=template&id=51053483&scoped=true"
import script from "./WashService.vue?vue&type=script&lang=js"
export * from "./WashService.vue?vue&type=script&lang=js"
import style0 from "./WashService.vue?vue&type=style&index=0&id=51053483&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51053483",
  null
  
)

export default component.exports